import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-options-icon',
  templateUrl: './options.svg',
  styleUrls: ['./options-icon.component.scss'],
})
export class OptionsIconComponent {
  @Input() options: {strokeColor: '#FF7F50' | 'white' | 'none' | '#808080' | '#474747', fillColor: '#FF7F50' | 'white' | 'none' | '#808080' | '#474747'} = {
    strokeColor: '#808080', fillColor: '#808080'
  };
  @Input() circle: {strokeColor: '#D1433A' | 'white' | 'none', fillColor: '#D1433A' | 'white' | 'none'} = {
    strokeColor: '#D1433A', fillColor: '#D1433A'
  };
}
